export class DowloadPrintOUTModel {
  resource: string
}